import React, { useEffect, useState, useRef } from "react";
import Button from "../../common/Button";
import warning from "../assets/warning.png";
import info from "../assets/info.png";
import ScmModuleStyle from "../styles/scm.module.css";
import CalcAnalysisGraph from "./CalcAnalysisGraph";
import GizmozGraph from "./GizmozGraph";

const CalProfitLoss = ({ popupState,getUserData }) => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, accordionPopup, setAccordionPopup, simObj, setSimObj, formatNum, toggleSimulation, scmPopup, setScmPopup] = popupState;

  const cost = simObj?.laststate?.cost;
  const quarter = simObj?.laststate?.quarter;
  const availableBudget = simObj?.laststate?.availableBudget > 0 ? simObj?.laststate?.availableBudget : 0;
  const totalBudget = simObj?.laststate?.totalBudget;
  const yeartodateBudget = simObj?.laststate?.yeartodateBudget;
  const linedUpOrderCost = simObj?.laststate?.linedUpOrderCost;
  const noOfGizmosCompleted = simObj?.laststate?.noOfGizmosCompleted;
  const quarterlyGizmosTarget = simObj?.laststate?.quarterlyGizmosTarget;
  const totalProfit = simObj?.laststate?.totalProfit;
  const totalComponent1Completed = simObj?.laststate?.totalComponent1Completed;
  const totalComponent1Ordered = simObj?.laststate?.totalComponent1Ordered;
  const totalComponent2Completed = simObj?.laststate?.totalComponent2Completed;
  const totalComponent2Ordered = simObj?.laststate?.totalComponent2Ordered;
  const totalGizmosToBeCompleted = simObj?.laststate?.totalGizmosToBeCompleted;
  const gizmosCompletedPercentage = simObj?.laststate?.gizmosCompletedPercentage > 100 ? 100 : simObj?.laststate?.gizmosCompletedPercentage;
  const compnent1ToBeOrdered = simObj?.compnent1ToBeOrdered;
  const compnent2ToBeOrdered = simObj?.compnent2ToBeOrdered;
  const totalComponent1Cost = simObj?.laststate?.totalComponent1Cost;
  const totalComponent2Cost = simObj?.laststate?.totalComponent2Cost;
  const totalBidRequestCost = simObj?.laststate?.totalBidRequestCost;
  const TotalProcurementCost = simObj?.laststate?.totalProcurementCost;
  const totalProcurementCostPercentage = simObj?.laststate?.totalProcurementCostPercentage;
  const TargetSR = simObj?.laststate?.TargetSR;
  const yearlyProfitTarget = simObj?.laststate?.yearlyProfitTarget;
  // const RemainingBudget = availableBudget;
  const progressbar = {
    valuemin: 0,
    valuemax: simObj?.laststate?.yearlyProfitTarget,
    valuenow: function () {
      return Math.round((simObj?.laststate?.totalProfit / this.valuemax) * 100);
    },
  };

  const [weeksRemaining, setWeeksRemaining] = useState(0);
  const [shouldRenderSpan, setShouldRenderSpan] = useState(false);
  const [isToggledFinalProd, setIsToggledFinalProd] = useState(false);
  const [isToggledTotalCost, setIsToggledTotalCost] = useState(false);
  const detailsGizmosRef = useRef(null);
  const detailsGizmosBtnRef = useRef(null);
  const detailProcureRef = useRef(null);
  const detailProcureBtnRef = useRef(null); 
  //const [isFluidPopup1, setIsFluidPopup1] = useState(false);
  //const [isFluidPopup2, setIsFluidPopup2] = useState(false);
  /*Final Product I-Icon*/ 
  const handleToggleFinalProd = (event) => {
    if(event === undefined){
      return;
    }
    setIsToggledFinalProd((prev) => {
    const next = !prev;
    // Focus popup when it opens
    if (!prev) {
      setTimeout(() => detailsGizmosRef.current?.focus(), 150);
    }
    return next;
    });
  };
  
  const handleKeyDownFinalProd = (event) => {
    // Toggle the button when Enter or Space is pressed
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      // Toggle the popup
      setIsToggledFinalProd((prev) => {
        const next = !prev;
        // Focus popup when it opens
        if (!prev) {
          setTimeout(() => detailsGizmosRef.current?.focus(), 150);
        }
        // If the popup is closing, set focus back to the info icon
        if (prev) {
          setTimeout(() => detailsGizmosBtnRef.current?.focus(), 100);
        }
        return next;
      });
      setIsToggledTotalCost(false); // Optionally close the profit-loss popup if it's open
    } else if (event.key === "Escape") {
      // Close popup when pressing Escape
      setIsToggledFinalProd(false);
      setTimeout(() => detailsGizmosBtnRef.current?.focus(), 100); // Return focus to the info icon
    } else if (event.key === "Tab") {
      setIsToggledFinalProd(false);
    }
  };
//   window.$(document).on("click", function(e){
//     if(!window.$(e.target).closest('#detailsGizmos').length > 0){
//       setIsToggledFinalProd(false);
//     }
//  })

   /*Total Procurement Cost Product I-Icon*/ 
   const handleToggleTotalcost = (event) => {
    if(event === undefined){
      return;
    }
    setIsToggledTotalCost((prev) => {
      const next = !prev;
      if(!prev) {
        setTimeout(() => detailProcureRef.current?.focus(), 150);
      }
      return next;
    });
  };
  
  const handleKeyDownTotalcost = (event) => {
    // Toggle the button when Enter or Space is pressed
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      // Toggle the popup
      setIsToggledTotalCost((prev) => {
        const next = !prev;
        // Focus popup when it opens
        if (!prev) {
          setTimeout(() => detailProcureRef.current?.focus(), 150);
        }
        // If the popup is closing, set focus back to the info icon
        if (prev) {
          setTimeout(() => detailProcureBtnRef.current?.focus(), 100);
        }
        return next;
      });
      
      setIsToggledFinalProd(false); // Optionally close the profit-loss popup if it's open
    } else if (event.key === "Escape") {
      // Close popup when pressing Escape
      setIsToggledTotalCost(false);
      setTimeout(() => detailProcureBtnRef.current?.focus(), 100); // Return focus to the info icon
    } else if (event.key === "Tab") {
      setIsToggledTotalCost(false);
    }
  };
  //   window.$(document).on("click", function(e){
  //     if(!window.$(e.target).closest('#detailProcureCost').length > 0){
  //       setIsToggledTotalCost(false);
  //     }
  //  })

/*
  const clickHandler = (e) => {
    let image1 = document.querySelector("#detailsGizmos img");
    if (e.target != image1) {
      setIsFluidPopup1(false);
    }
    let image2 = document.querySelector("#detailProcureCost img");
    if (e.target != image2) {
      setIsFluidPopup2(false);
    }
  }
  useEffect(() => {
    const detailsIcon1 = document.querySelector("#detailsGizmos");
    detailsIcon1.addEventListener("focus", () => {
      setIsFluidPopup1(true)
      detailsIcon1.style.setProperty("outline", "none", "important");
    });
    detailsIcon1.addEventListener("blur", () => {
      setIsFluidPopup1(false)
    });

    const totalProcCostBlock = document.querySelector("#detailProcureCost");
    totalProcCostBlock.addEventListener("focus", () => {
      setIsFluidPopup2(true);
      totalProcCostBlock.style.setProperty("outline", "none", "important");
    });
    totalProcCostBlock.addEventListener("blur", () => {
      setIsFluidPopup2(false);
    });

    if (window.innerWidth > 991) {
      document.querySelector('#GizmosManufactured').addEventListener("mouseenter", () => setIsFluidPopup1(true));
      document.querySelector('#GizmosManufactured').addEventListener("mouseleave", () => setIsFluidPopup1(false));
      document.querySelector("#totProcurementCost").addEventListener("mouseenter", () => setIsFluidPopup2(true));
      document.querySelector("#totProcurementCost").addEventListener("mouseleave", () => setIsFluidPopup2(false));

    }
  }, []);
  useEffect(() => {
    setTimeout(() => {
      if (isFluidPopup1 || isFluidPopup2) {
        document.addEventListener("click", clickHandler);
      }
    }, 1000);
    if (!isFluidPopup1 || !isFluidPopup2) {
      document.removeEventListener("click", clickHandler);
    }
  }, [isFluidPopup1, isFluidPopup2]) */
  const noOfRatings = [1, 2, 3, 4, 5];
  const calculateWeeksRemaining = () => {
    if (simObj) {
      const newWeeksRemaining = Math.ceil((simObj?.laststate?.daysleft) / 7);
      if (weeksRemaining !== newWeeksRemaining) {
        setWeeksRemaining(newWeeksRemaining);
        setShouldRenderSpan(true);
      } else {
        setShouldRenderSpan(false);
      }
      //console.log(newWeeksRemaining,weeksRemaining)
    }
  };
  const formatStarNum = (number) => {
    let formattedNumber = number.toString();
    formattedNumber = formattedNumber.includes('.') ? formattedNumber.replace(/\.?0*$/, '') : formattedNumber;
    return formattedNumber;
  }
  useEffect(() => {
    calculateWeeksRemaining();
  }, [simObj?.currentstep]);

  useEffect(() => {
    const handleClickOutsideGizmos  = (e) => {
      const btnGizmos = detailsGizmosBtnRef.current;
      const popupGizmos = detailsGizmosRef.current;
      if (
        popupGizmos &&
        !popupGizmos.contains(e.target) &&
        btnGizmos &&
        !btnGizmos.contains(e.target)
      ) {
        setIsToggledFinalProd(false);
      }
    };

    document.addEventListener("click", handleClickOutsideGizmos);
    return () => document.removeEventListener("click", handleClickOutsideGizmos);
  }, []);

  useEffect(() => {
    const handleClickOutsideTotalCost  = (e) => {
      const btnTotalCost = detailProcureBtnRef.current;
      const popupTotalCost = detailProcureRef.current;
      if (
        popupTotalCost &&
        !popupTotalCost.contains(e.target) &&
        btnTotalCost &&
        !btnTotalCost.contains(e.target)
      ) {
        setIsToggledTotalCost(false);
      }
    };

    document.addEventListener("click", handleClickOutsideTotalCost);
    return () => document.removeEventListener("click", handleClickOutsideTotalCost);
  }, []);


  // const graph1data = [
  //   {
  //     name: "Remaining Budget",
  //     y:availableBudget != undefined && availableBudget, //
  //     color: "#ff5252", // Set the background color for 'Ordering Cost'
  //   },
  //   {
  //       name: "Total Procurement Cost",
  //       y:TotalProcurementCost  != undefined && TotalProcurementCost ,
  //       color: "#c6c9c5", // Set the background color for 'Ordering Cost'
  //   }
  // ];
  // const graph2data = [
  //   {
  //     name: "Gizmos Quarterly Goal",
  //     y:2400,
  //     color: "#ff5252", // Set the background color for 'Ordering Cost'
  //   },
  //   {
  //       name: "Total Procurement Cost",
  //       y:600,
  //       color: "#c6c9c5", // Set the background color for 'Ordering Cost'
  //   }
  // ];


  return (
    <div className={`${ScmModuleStyle["profit-loss"]} ${scmPopup?.scmKpis ? `show ${ScmModuleStyle['show']}` : ''}`}>

      <div className={`${ScmModuleStyle["tot-revenue"]} ${scmPopup?.gizmosProcKpis ? `show ${ScmModuleStyle['show']}` : ''}`}>
        <div className={`${ScmModuleStyle["Gizmos-manufactured"]}`} id="GizmosManufactured">
          <div className={`${ScmModuleStyle["InfoIcon-popup"]}`}>
           
            <div className={`${ScmModuleStyle['title-icon-div']}`}>
              <h3 className={`${ScmModuleStyle["pl-header"]}`}>
                Final Products Manufactured
              </h3>
              <a id={`${ScmModuleStyle.detailsGizmos}`} ref={detailsGizmosBtnRef} href="javascript:void(0)" role="button" aria-label="Info about Final Products Manufactured" onClick={handleToggleFinalProd}
                onKeyDown={handleKeyDownFinalProd}
                // onMouseEnter={()=> {
                //   if(window.innerWidth > 991) {
                //     setIsToggledFinalProd(true);
                //   }
                // }}
                // onMouseLeave={()=> {
                //   if(window.innerWidth > 991) {
                //     setIsToggledFinalProd(false);
                //   }
                // }}
                // onBlur={()=> setIsToggledFinalProd(false)}
              ><img src={info} alt="" aria-hidden="true" role="presentation" width={13}/></a>
              <div ref={detailsGizmosRef} tabIndex={-1} role="dialog" aria-live="polite" className={`ui fluid popup right center transition ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup} ${ScmModuleStyle["final-product-popup"]}`} style={{ display: isToggledFinalProd ? "block" : "none" }} onKeyDown={handleKeyDownFinalProd}>
                <ul className={`${ScmModuleStyle["popup-goal"]}`} role="list">
                  <li role="listitem">
                    <span>Final Products Manufactured in quarter {quarter}</span>
                    <span>
                      <strong>
                        {formatNum(Math.round(noOfGizmosCompleted != undefined ? noOfGizmosCompleted : 0))}
                      </strong>
                    </span>
                  </li>
                  <li role="listitem">
                    <span>Quarterly Goal</span>
                    <span>
                      <strong>
                        {formatNum(Math.round(quarterlyGizmosTarget != undefined ? quarterlyGizmosTarget : 0))}
                      </strong>
                    </span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
          <p className={`tr-content tc-content ${ScmModuleStyle.bld}`}>
            {gizmosCompletedPercentage != undefined ? gizmosCompletedPercentage : 0}%
          </p>
          <div className={`${ScmModuleStyle["quarter-progress"]}`}>
            <div className={`${ScmModuleStyle.progress}`} role="progressbar"
              aria-valuenow={gizmosCompletedPercentage}
              aria-valuemin={0}
              aria-valuemax={progressbar.valuemax}
              aria-valuetext={`${gizmosCompletedPercentage}%`}>
              <div className={`background`} id={`${ScmModuleStyle.profitLoss}`}>
                <div className={`${ScmModuleStyle['progress-fg']}`} style={{
                  width: gizmosCompletedPercentage ? gizmosCompletedPercentage + '%' : '0%',
                  background: gizmosCompletedPercentage >= 0 && gizmosCompletedPercentage <= 20
                    ? "#DB0020" : gizmosCompletedPercentage > 20 && gizmosCompletedPercentage <= 40
                      ? "#EA7600" : gizmosCompletedPercentage > 40 && gizmosCompletedPercentage <= 70
                        ? "#84BD00" : gizmosCompletedPercentage > 70 && gizmosCompletedPercentage <= 100
                          ? "#008000" : "#DB0020"
                }}>
                </div>
              </div>
            </div>
            <div className={`${ScmModuleStyle["quarter-line"]}`}>
              <>
                <div style={{ "width": "20%" }}>Q1</div>
                <div style={{ "width": "20%" }}>Q2</div>
                <div style={{ "width": "30%" }}>Q3</div>
                <div style={{ "width": "30%" }}>Q4</div>
              </>
            </div>
          </div>
        </div>
        <span className={`${ScmModuleStyle["verticleLine"]}`}></span>
        <hr className={`${ScmModuleStyle["bordered-hr"]}`} />
        <div className={`${ScmModuleStyle["pl-progress"]} ${scmPopup?.gizmosProcKpis ? `show ${ScmModuleStyle['show']}` : ''}`} id="progressed-goal">
          <div className={` ${plPopup ? `show ${ScmModuleStyle["show"]}` : ""}`} id={`${ScmModuleStyle["totProcurementCost"]}`}>
            <div>
              <h3 className={`${ScmModuleStyle["pl-header"]}`}>Total Procurement Cost</h3>
              <a id={`${ScmModuleStyle.detailProcureCost}`} ref={detailProcureBtnRef} href="javascript:void(0)" role="button" aria-label="Info about Total Procurement Cost" onClick={handleToggleTotalcost}
                onKeyDown={handleKeyDownTotalcost}
                // onMouseEnter={()=> {
                //   if(window.innerWidth > 991) {
                //     setIsToggledTotalCost(true);
                //   }
                // }}
                // onMouseLeave={()=> {
                //   if(window.innerWidth > 991) {
                //     setIsToggledTotalCost(false);
                //   }
                // }}
                // onBlur={()=> setIsToggledTotalCost(false)}
              ><img src={info} alt="" aria-hidden="true" role="presentation" width={13} tabIndex={-1}/></a>
              <div ref={detailProcureRef} role="dialog" tabIndex={-1} aria-live="polite" className={`ui fluid popup right center transition ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup}`} style={{ display: isToggledTotalCost == true ? "block" : "none" }} onKeyDown={handleKeyDownTotalcost}>
              <ul className={`${ScmModuleStyle["procurement-popup"]}`} role="list">
                <li role="listitem">
                  <span>Year to Date Budget</span>
                  <span>
                    <strong>
                      ${formatNum(Math.round(yeartodateBudget != undefined ? yeartodateBudget : 0))}
                    </strong>
                  </span>
                </li>
                <li role="listitem">
                  <span>Total Procurement Cost</span>
                  <span>
                    <strong>
                      ${formatNum(Math.round(TotalProcurementCost != undefined ? TotalProcurementCost : 0))}
                    </strong>
                  </span>
                </li>
                <li role="listitem">
                  <span>Total Procurement Cost for SKU1</span>
                  <span>
                    <strong>
                      ${formatNum(Math.round(totalComponent1Cost != undefined ? totalComponent1Cost : 0))}
                    </strong>
                  </span>
                </li>
                <li role="listitem">
                  <span>Total Procurement Cost for SKU2</span>
                  <span>
                    <strong>
                      ${formatNum(Math.round(totalComponent2Cost != undefined ? totalComponent2Cost : 0))}
                    </strong>
                  </span>
                </li>
                <li role="listitem">
                  <span>Total bid request cost</span>
                  <span>
                    <strong>
                      ${formatNum(Math.round(totalBidRequestCost != undefined ? totalBidRequestCost : 0))}
                    </strong>
                  </span>
                </li>
              </ul>
            </div>
            </div>
            <p className={`${ScmModuleStyle['pl-amt']}`} ><strong>${formatNum(Math.round(TotalProcurementCost != undefined ? TotalProcurementCost : 0))} of ${formatNum(Math.round(totalBudget != undefined ? totalBudget : 0))} Budget</strong></p>
            <div className={`${ScmModuleStyle["quarter-progress"]}`}>
              <div className={`${ScmModuleStyle.progress}`} role="progressbar"
                aria-valuenow={totalProcurementCostPercentage}
                aria-valuemin={progressbar.valuemin}
                aria-valuemax={progressbar.valuemax}
                aria-valuetext={`${totalProcurementCostPercentage}%`}>
                <div className={`background`} id={`${ScmModuleStyle.profitLoss}`}>
                  <div className={`${ScmModuleStyle['progress-fg']}`} style={{
                    width: totalProcurementCostPercentage ? totalProcurementCostPercentage + '%' : '0%',
                    background: totalProcurementCostPercentage >= 0 && totalProcurementCostPercentage <= 20
                      ? "#DB0020" : totalProcurementCostPercentage > 20 && totalProcurementCostPercentage <= 40
                        ? "#EA7600" : totalProcurementCostPercentage > 40 && totalProcurementCostPercentage <= 70
                          ? "#84BD00" : totalProcurementCostPercentage > 70 && totalProcurementCostPercentage <= 100
                            ? "#008000" : "#DB0020"
                  }}>
                  </div>
                </div>
              </div>
              <div className={`${ScmModuleStyle["quarter-line"]}`}>
                <>
                  <div style={{ "width": "20%" }}>Q1</div>
                  <div style={{ "width": "20%" }}>Q2</div>
                  <div style={{ "width": "30%" }}>Q3</div>
                  <div style={{ "width": "30%" }}>Q4</div>
                </>
              </div>
            </div>

            


          </div>
        </div>
      </div>
      <hr aria-hidden="true" role="presentation"  className={`${ScmModuleStyle["barHr"]}`}/>
      {
        scmPopup?.gizmosProcKpis ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['gizmos-popup']}`} role='dialog' aria-modal="true" aria-label="Final products and manufactured popup" tabIndex={-1}>
          <p>{`Remember, your goal is to manufacture ${formatNum(simObj?.laststate?.totalGizmosToBeCompleted)} ${(simObj?.userData && simObj?.userData!="") ? getUserData(simObj?.userData,2) : "gizmos"} and keep procurement costs under $${formatNum(simObj?.laststate?.totalBudget)} within one year.`}</p>
          <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
            <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
              setScmPopup((prevScmPopup) => ({ ...prevScmPopup, ['gizmosProcKpis']: false, ['scmKpis']: true }))
            }} />
          </div>
        </div> : ''
      }
        <div className={`${ScmModuleStyle.circlegwrapper}`}>
              <div className={`${ScmModuleStyle.calcGraph_container}`} style={{width:'268px',padding: '8px 20px',borderRight: '1px solid rgba(0, 0, 0, 0.1)'}}>
                <CalcAnalysisGraph id={"RemainingGraph"} simObj={simObj} setSimObj={setSimObj} />
                <div className={`${ScmModuleStyle['CalProfitGraphs-legends']}`}>
                  <div className={`${ScmModuleStyle['CalProfitGraphslegend1']}`}><span className={`${ScmModuleStyle['CalProfitGraphspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['RemBudget-legend-sign1']}`}></div></span>Remaining Budget</div>
                  <div className={`${ScmModuleStyle['CalProfitGraphslegend2']}`}><span className={`${ScmModuleStyle['CalProfitGraphspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['totalProcurement-legend-sign2']}`}></div></span>Total Procurement Cost</div>
                </div>
              </div>
              <span className={`${ScmModuleStyle["verticleLine"]}`}></span>
              <div className={`${ScmModuleStyle.calcGraph_container}`} style={{width:'268px',padding: '8px 20px'}}>
                <GizmozGraph id={"GizmozGraph"} simObj={simObj} setSimObj={setSimObj} getUserData={getUserData}/>
                <div className={`${ScmModuleStyle['CalProfitGraphs-legends']}`}>
                  <div className={`${ScmModuleStyle['CalProfitGraphslegend1']}`}><span className={`${ScmModuleStyle['CalProfitGraphspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['GizmosCompleted-legend-sign1']}`}></div></span>{`${(simObj?.userData && simObj?.userData!="") ? getUserData(simObj?.userData,2).charAt(0).toUpperCase() + getUserData(simObj?.userData,2).slice(1) : "Gizmos"} Completed`}</div>
                  <div className={`${ScmModuleStyle['CalProfitGraphslegend2']}`}><span className={`${ScmModuleStyle['CalProfitGraphspattern']}`} aria-hidden="true" role="presentation"><div className={`${ScmModuleStyle['GizmosRemaining-legend-sign2']}`}></div></span>{`${(simObj?.userData && simObj?.userData!="") ? getUserData(simObj?.userData,2).charAt(0).toUpperCase() + getUserData(simObj?.userData,2).slice(1) : "Gizmos"} Remaining`}</div>
                </div>
              </div>
         </div>
    </div>
  );
};

export default CalProfitLoss;
